<style scoped>
.justify {
  text-align: justify;
}
hr.divider {
  border: 1px solid #f2f2f2;
  background: transparent;
  margin: 10px 50px;
}
</style>

<template>
  <app-layout class="feed-single-page-template">
   <Row type="flex" justify="center" style="height: 100vh">
      <Col :span="24" style="text-align: center; top: 40vh;">
        <h1>
          Coming soon...
        </h1>
      </Col>
    </Row>
  </app-layout>
</template>

<script>
export default {
  name: 'AboutUsSingleComponent'
}
</script>
